import proxy from "../api/axios";
import { languageMapping } from "./constants";

export const formatString = (str) => {
  // Replace newline characters with <br />
  // Replace tab characters with a fixed width space
  return String(str ?? '')
    .replace(/\n/g, '<br />') // Convert newlines to <br />
    .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;'); // Convert tabs to spaces (4 spaces here)
};

// Re-export problem sanitizer for convenience
export {
  sanitizeProblemText,
  formatProblemHtml,
  needsProblemSanitize,
} from './sanitizeProblemHtml';


export const getToken = () => {
  return localStorage.getItem('token') || '';
}

/** Resolve stored profile image path/URL for <Avatar src>. */
export const resolveProfileImage = (src) => {
  if (!src) return undefined;
  if (/^(https?:|data:|blob:)/i.test(src)) return src;

  const path = src.startsWith('/') ? src : `/${src}`;
  const apiBase = process.env.REACT_APP_API_URL || '';

  if (/^https?:\/\//i.test(apiBase)) {
    try {
      return `${new URL(apiBase).origin}${path}`;
    } catch {
      return path;
    }
  }

  if (process.env.REACT_APP_BACKEND_ORIGIN) {
    return `${process.env.REACT_APP_BACKEND_ORIGIN.replace(/\/$/, '')}${path}`;
  }

  if (typeof window !== 'undefined') {
    // Production: React is served from the same Express app as /uploads
    if (process.env.NODE_ENV === 'production') {
      return `${window.location.origin}${path}`;
    }
    // CRA dev server — uploads live on the backend (default port 5000)
    return `http://localhost:${process.env.REACT_APP_BACKEND_PORT || '5000'}${path}`;
  }

  return path;
};

/** Keep Redux + localStorage session user in sync after profile changes. */
export const syncSessionUser = (partial) => {
  try {
    const raw = localStorage.getItem('user');
    const current = raw ? JSON.parse(raw) : {};
    const next = { ...current, ...partial };
    localStorage.setItem('user', JSON.stringify(next));
    return next;
  } catch {
    return partial;
  }
};

export const formatDateTime = (dateTime) => {
  const dateObj = new Date(dateTime);
  const date = dateObj.toLocaleDateString();
  const time = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return { date, time };
};

/** LeetCode-style problem title (e.g. "two sum" → "Two Sum"). */
export const formatProblemTitle = (title) =>
  String(title ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => {
      if (/^[ivxlcdm]+$/i.test(word) && word.length <= 6) {
        return word.toUpperCase();
      }
      const match = word.match(/^([^A-Za-z]*)([A-Za-z])(.*)$/);
      if (!match) return word;
      const [, prefix, first, rest] = match;
      return `${prefix}${first.toUpperCase()}${rest.toLowerCase()}`;
    })
    .join(' ');

// Utility function to shuffle an array
export const shuffleArray = (array) => {
  return array?.sort(() => Math.random() - 0.5);
};

export const generateRandomString = (length = 8) => {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}

export const runCode = async (code, language, testCase) => {
  try {
    const requestBody = {
      source_code: code,
      language_id: languageMapping[language],
      testCase
    };

    const { data } = await proxy.post('/code/compile', requestBody, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}